<div class="issues-page">
  <app-issues-map></app-issues-map>
</div>
